window.getThemeInfoWindow = (location, type) => {
  // If the type is a office
  if (type == 'office') {
    const showManager = false;
    const image = `
      <div class="higgins-map-info__layout-item">
        <div class="higgins-map-info__image" style="background-image: url('${location.infoWindow.image}')"></div>
      </div>
    `;
    const manager = `
      <div class="higgins-map-info__manager">
        <div class="higgins-map-info__layout">
          ${location.infoWindow.image ? image : ''}
          <div class="higgins-map-info__layout-item">
            <div class="higgins-map-info__details">
              <div class="higgins-map-info__name">${location.infoWindow.manager}</div>
              ${location.infoWindow.managerRole ? '<div class="higgins-map-info__role">' + location.infoWindow.managerRole + '</div>' : ''}
            </div>
          </div>
        </div>
      </div>
    `;
    return `
      <div class="higgins-map-info">
        <div class="higgins-map-info__wrap">
          <div class="higgins-map-info__main">
            <div class="higgins-map-info__title">${location.infoWindow.title}</div>
            <div class="higgins-map-info__address">${location.address}</div>
            ${location.phone ? '<div class="higgins-map-info__phone">Phone: ' + location.phone + '</div>' : ''}
            <div class="higgins-map-info__link"><a class="read-more" href="${location.contactPage + '#' + location.id}">View all contacts</a></div>
          </div>

          ${location.infoWindow.manager && showManager ? manager : ''}
        </div>
      </div>
    `;
  }

  // // If the type is an project
  // if (type == 'project') {
  //   console.log(location);
  // }

  // Return nothing
  return false;
};